// ✅ src/components/Todo/TodoItem.js
import React from "react";

const TodoItem = ({ task, onToggleComplete, onClick, onTagClick, onDelete }) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onToggleComplete(task.id, task.is_completed);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete(task.id);
  };

  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl shadow-sm p-4 mb-4 border border-gray-200 hover:shadow-md transition cursor-pointer relative"
    >
      <div className="flex items-start">
        <button
          onClick={handleCheckboxClick}
          className={`w-5 h-5 mr-3 rounded-full border-2 mt-1 ${
            task.is_completed ? "bg-blue-500 border-blue-500" : "border-gray-300"
          }`}
        />

        <div className="flex-1">
          <div className={`text-lg font-semibold ${task.is_completed ? "line-through text-gray-400" : ""}`}>
            {task.title}
          </div>

          {task.due_date && (
            <div className="text-sm text-gray-500 mt-1">📅 마감일: {task.due_date}</div>
          )}

          <div className="mt-2 space-x-2">
            {task.tags?.map((tag) => (
              <button
                key={tag}
                onClick={(e) => {
                  e.stopPropagation();
                  onTagClick(tag);
                }}
                className="text-xs bg-gray-100 hover:bg-blue-100 text-gray-700 px-2 py-1 rounded"
              >
                #{tag}
              </button>
            ))}
          </div>
        </div>

        <button
          onClick={handleDeleteClick}
          className="text-red-400 hover:text-red-600 ml-4 text-sm"
          title="삭제"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default TodoItem;
